/**
 * ZenMarkup Privacy Analytics — Dashboard entry point.
 *
 * Orchestrates module initialization only — no business logic here.
 */

import * as state from './state.js';
import * as ui from './ui.js';
import * as api from './api.js';
import * as campaigns from './campaigns.js';
import * as insights from './insights.js';
import * as insightsJourneys from './insights-journeys.js';
import * as insightsEvents from './insights-events.js';
import * as charts from './charts.js';
import * as overview from './overview-widgets.js';
import * as lineChart from './line-chart.js';
import * as pieChart from './pie-chart.js';
import * as widgets from './widgets.js';
import * as map from './map.js';
import { formatCompact } from './utils.js';

document.addEventListener('DOMContentLoaded', function () {
	state.init();
	ui.init();
	campaigns.init();
	api.fetchStats().then(function (data) {
		if (!data) {
			return;
		}
		ui.showContent();
		insights.renderDeadPages(data);
		insights.render404Pages(data);
		insightsJourneys.render(data);
		insightsEvents.render(data);
		charts.render(data);
		campaigns.render(data);
		overview.render(data);
		lineChart.render(data.timeseries);
		pieChart.render(data.new_returning);
		widgets.render(data);
		map.render(data);
	});

	/* ── Live online counter ── */

	const POLL_INTERVAL = 30000;
	const originalTitle = document.title;
	let pollTimer = null;

	function updateOnlineCount() {
		api.fetchOnline().then(function (count) {
			if (count === null) {
				return;
			}

			const indicator = document.querySelector('[data-el="online-indicator"]');
			const countEl   = document.querySelector('[data-el="online-count"]');

			if (!indicator || !countEl) {
				return;
			}

			if (count > 0) {
				countEl.textContent = formatCompact(count);
				indicator.style.display = '';
				indicator.classList.add('zmpa-online-active');
				document.title = '(' + count + ') ' + originalTitle;
			} else {
				indicator.style.display = 'none';
				indicator.classList.remove('zmpa-online-active');
				document.title = originalTitle;
			}
		});
	}

	function startPolling() {
		if (pollTimer) {
			return;
		}
		updateOnlineCount();
		pollTimer = setInterval(updateOnlineCount, POLL_INTERVAL);
	}

	function stopPolling() {
		if (pollTimer) {
			clearInterval(pollTimer);
			pollTimer = null;
		}
	}

	startPolling();

	document.addEventListener('visibilitychange', function () {
		if (document.hidden) {
			stopPolling();
		} else {
			startPolling();
		}
	});
});
